import { format } from 'date-fns'
import { get } from 'lodash'
import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'

import MenuButton from '@/components/buttons/MenuButton'
import MenuItem from '@/components/buttons/MenuItem'
import { Language } from '@/components/Icons'

import messages from './messages'

const StyledLanguageIcon = styled(Language)`
  color: var(--wg-dark-blue);
  margin-left: 1rem;
`

export default ({
  intl,
  onCloneNotification,
  onSelectNotification,
  showConfirmDelete,
  showConfirmRecall,
  showDeleted,
  toggleShowDeleted,
  navigateToLogs
}: any) => [
  {
    property: 'title',
    header: {
      label: intl.formatMessage(messages.title),
      sortable: true
    },

    cell: {
      formatters: [
        (title: any, { rowData }: any) => (
          <div className="publisher-notification-row-title">
            {get(rowData, 'summary.title', title)}
            {rowData?.totalLocales > 1 ? <StyledLanguageIcon /> : ''}
          </div>
        )
      ]
    }
  },
  {
    property: 'status',
    header: {
      label: intl.formatMessage(messages.status),
      sortable: true
    },
    cell: {
      formatters: [
        (status: any, { rowData }: any) => (
          <div className="publisher-notification-row-title">{get(rowData, 'publisher.status', status)}</div>
        )
      ]
    }
  },
  {
    property: 'hiddenBefore',
    header: {
      label: intl.formatMessage(messages.published),
      sortable: true
    },
    cell: {
      formatters: [
        (hiddenBefore: any) => {
          return <span>{hiddenBefore && format(new Date(hiddenBefore), 'MM/dd/yy K:mm aaa')}</span>
        }
      ]
    }
  },
  {
    property: 'createdByDisplayName',
    header: {
      label: intl.formatMessage(messages.createdBy),
      sortable: true
    },
    cell: {
      formatters: [
        (createdByDisplayName: any, { rowData }: any) => (
          <span>{get(rowData, 'publisher.createdByDisplayName', createdByDisplayName)}</span>
        )
      ]
    }
  },
  {
    property: 'category',
    header: {
      label: intl.formatMessage(messages.category),
      sortable: true
    },
    cell: {
      formatters: [
        (category: any, { rowData }: any) => <span>{get(rowData, 'localizations["en-US"].category', category)}</span>
      ]
    }
  },
  {
    property: 'id',
    header: {
      formatters: [
        () => (
          // eslint-disable-next-line jsx-a11y/no-static-element-interactions
          <div className="publisher-archived" onClick={toggleShowDeleted}>
            {showDeleted ? intl.formatMessage(messages.hideDeleted) : intl.formatMessage(messages.showDeleted)}
          </div>
        )
      ]
    },
    cell: {
      formatters: [() => {}]
    }
  },
  {
    property: 'id',
    cell: {
      formatters: [
        // add this back in once real metrics are in place
        //            <MenuItem value="0" onClick={() => onSelectNotification(rowData.id)}>
        //              <FormattedMessage {...messages.selectNotification} />
        //            </MenuItem>
        (id: any, { rowData }: any) => (
          <MenuButton className="publisher-menu">
            {get(rowData, 'publisher.status', get(rowData, 'status')) === 'Draft' && (
              <MenuItem onClick={() => onSelectNotification(rowData.id)}>
                <FormattedMessage {...messages.editNotification} />
              </MenuItem>
            )}
            <MenuItem onClick={() => onCloneNotification(rowData.id)}>
              <FormattedMessage {...messages.cloneNotification} />
            </MenuItem>
            {get(rowData, 'publisher.status', get(rowData, 'status')) === 'Active' && (
              <MenuItem onClick={() => showConfirmRecall(rowData.id)}>
                <FormattedMessage {...messages.recallNotification} />
              </MenuItem>
            )}
            {get(rowData, 'publisher.status', get(rowData, 'status')) !== 'Active' &&
              get(rowData, 'publisher.status', get(rowData, 'status')) !== 'Deleted' && (
                <MenuItem onClick={() => showConfirmDelete(rowData.id)}>
                  <FormattedMessage {...messages.deleteNotification} />
                </MenuItem>
              )}
            {get(rowData, 'publisher.status', get(rowData, 'status')) !== 'Draft' && (
              <MenuItem onClick={() => navigateToLogs(rowData.id)}>
                <FormattedMessage {...messages.viewAnalytics} />
              </MenuItem>
            )}
          </MenuButton>
        )
      ],
      props: {
        style: {
          width: 50,
          textAlign: 'right'
        }
      }
    }
  }
]
